import type { LoaderFunctionArgs } from '@remix-run/node';
import { listBuildHubs } from '@modules/build-hub/api/list-build-hubs.server';

export const ACTION_GET_BUILD_HUBS_LIST = '/actions/get-build-hubs-list';

export const loader = async ({ context }: LoaderFunctionArgs) => {
    return await listBuildHubs(context);
};
